export const isMicroApp = window.__POWERED_BY_QIANKUN__;

export const isBSP = !!window.__INSIDE_MSP__;
